export var CONNECTOR_TABS = [
    'PERSONAL_BANK',
    'BUSINESS_BANK',
    'INVESTMENT',
    'OTHER',
];
